<a
    *appHasPermissionId="permissionList.kpiRead; else justNameTemplateRef"
    [routerLink]="['', 'kpi', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
